import Portal from 'components/portals/Portal'
import Deals from 'components/Deals/Deals'

const DealPortal = ({ dealData, id }) => (
  <Portal elementId={id} component={<Deals data={dealData} />} />
)

export default DealPortal
